import React from "react";
import ButtonBase, { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import { useTheme, createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LogoMain from "../../../../../assets/images/logo.svg";
import LogoInverse from "../../../../../assets/images/logo-inverse.svg";
import LogoMobile from "../../../../../assets/images/logo-mobile.svg";

export interface LogoProps extends ButtonBaseProps {
  inverse?: boolean;
}

// styles
const useLogoStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      objectFit: "cover",
      [theme.breakpoints.up("lg")]: {
        height: 90,
      },
    },
    icon: {
      display: "inline-block",
      margin: "10px",
      "&:focus": {
        margin: "6px",
        border: "black 2px solid",
        borderRadius: 3,
        padding: "2px 2px 2px 2px",
      },
    },
  })
);

const Logo: React.FC<LogoProps> = ({ inverse, ...props }) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const classes = useLogoStyles();

  return (
    <a href="https://www.ncqa.org" id="logo-link" className={classes.icon} target="_blank" rel="noopener noreferrer">
      <img
        className={classes.logo}
        src={lgUp ? (inverse ? LogoInverse : LogoMain) : LogoMobile}
        alt="NCQA Measuring quality, improving health care - Homepage"
      />
    </a>
  );
};

export default React.memo(Logo);
